export default __webpack_public_path__ + "static/media/webinar-icon.f84623e9.png";